import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { CreateDetectorModal } from "components/createDetector/CreateDetectorModal";

export function CreatePredictorPage() {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(true);

  return (
    <CreateDetectorModal
      dialogOpen={dialogOpen}
      setDialogOpen={setDialogOpen}
      onPage
      onClose={() => navigate("/reef/detectors")}
    />
  );
}
